import maintenanceRequests from './maintenanceRequests'

export default { maintenanceRequests }
